import { SimpleTable } from '@/components/tables';
import { MainContentWrapper } from '@/features/layout/main';
import { useUserInfo } from '@/features/userInfo/hooks';
import { FunctionComponent } from 'react';
import { WorkspaceInviteRow } from './WorkspaceInviteRow';

export const WorkspaceInvites: FunctionComponent = () => {
  const userInfo = useUserInfo();

  return (
    <MainContentWrapper childClassName='relative grid grid-cols-2 h-full px-12 py-14'>
      {userInfo.workspaceInvites && userInfo.workspaceInvites.length ? (
        <div className='col-span-2'>
          <h1 className='text-lg text-black-100 font-semibold'>Workspaces</h1>
          {!userInfo.workspaceInvites || !userInfo.workspaceInvites.length ? (
            <div className='border rounded-lg mb-2 p-6 font-base text-sm text-gray-600'>No invites from other workspaces, yet</div>
          ) : (
            <div className='mb-2'>
              <SimpleTable>
                <tbody>
                  {userInfo.workspaceInvites
                    .filter((i) => i.status == 'PENDING')
                    .map((invite) => (
                      <WorkspaceInviteRow key={invite.workspaceId} invite={invite} />
                    ))}
                </tbody>
              </SimpleTable>
            </div>
          )}
        </div>
      ) : null}
    </MainContentWrapper>
  );
};
